const projects = [
  {
    imageUrl:
      "https://ivanmolto.mypinata.cloud/ipfs/QmcgTj3VJkyxS9B9esFSeR2r1DiypanHGcLDYYDoAN4tco",
    name: "Knoxers",
    description:
      "A Learn2Earn DAO governed by Knoxers NFT house & $KNOX token house",
    twitterUrl: "https://twitter.com/KnoxEdgeDAO",
    celoUrl:
      "https://explorer.celo.org/address/0x1F25F8Df9E33033668d6F04DAE0bDE4854E9F1A5/transactions",
  },
  {
    imageUrl:
      "https://ivanmolto.mypinata.cloud/ipfs/QmSPeorYjkGtMkZGFGwQ8G9yKaRRKz8jDj4wUexJbhoGMc",
    name: "Celostrials",
    description:
      "An intergalactic collection of unique beings, found exclusively on the Celo Blockchain",
    twitterUrl: "https://twitter.com/celostrials",
    celoUrl:
      "https://explorer.celo.org/address/0xAc80c3c8b122DB4DcC3C351ca93aC7E0927C605d/transactions",
  },
  {
    imageUrl:
      "https://ivanmolto.mypinata.cloud/ipfs/QmWKFts3d1knWiVZqNJygo6Q5qLivgSpiyAd9EuY1ySyts",
    name: "Chinchilla Gang",
    description: "A Gang of 8888 Chinchilla Living On Celo",
    twitterUrl: "https://twitter.com/Chinchilla_Gang",
    celoUrl:
      "https://explorer.celo.org/address/0xc8DF51073CD581902b4fb50131d31f29343131F0/transactions",
  },
  {
    imageUrl:
      "https://ivanmolto.mypinata.cloud/ipfs/QmXv37iKkjaNWENU6McsiCKcc2tfz3EypZDcVEbkiDQW13",
    name: "CeloPunks",
    description:
      "Algorithmically generated Punks with new and unique attributes on Celo!",
    twitterUrl: "https://twitter.com/CeloPunks",
    celoUrl:
      "https://explorer.celo.org/address/0x9f46B8290A6D41B28dA037aDE0C3eBe24a5D1160/transactions",
  },
  {
    imageUrl:
      "https://ivanmolto.mypinata.cloud/ipfs/QmYDGqB4Hcrj83nsiXePp5B83pDe1mZT36f6aUbuyjwerq",
    name: "MooPunks",
    description: "Democratizing finances",
    twitterUrl: "https://twitter.com/Moola_Market",
    celoUrl: "",
  },
  {
    imageUrl:
      "https://ivanmolto.mypinata.cloud/ipfs/QmT3wjyfJD9gxcFgQjLiXfBwN8PT9eMRLnZCyQkWBcfs97",
    name: "Celo Apes Kingdom",
    description: "A collection of 10000 Apes NFT",
    twitterUrl: "https://twitter.com/Celo_Apes",
    celoUrl:
      "https://explorer.celo.org/address/0x1eCD77075F7504bA849d47DCe4cdC9695f1FE942/transactions",
  },
  {
    imageUrl:
      "https://gateway.pinata.cloud/ipfs/QmSx2KrM9npVfWEVAm5jPxD1Uv9EjmycoKFYtDdoGqepqZ",
    name: "Nomstronauts",
    description: "A global name resolution service",
    twitterUrl: "https://twitter.com/nomspace_nom",
    celoUrl: "",
  },
  {
    imageUrl:
      "https://gateway.pinata.cloud/ipfs/QmSac87GtKiMxc8q94JovWdT8dmSpTugXjuMSNrj23aPYm",
    name: "CeloPaints",
    description:
      "Generative abstract art collection of 444 NFTs on Celo blockchain",
    twitterUrl: "https://twitter.com/CeloPaintsNFT",
    celoUrl:
      "https://explorer.celo.org/address/0x660C6442F01c75fE1e389A607A4a7662342f2FD2/transactions",
  },
  {
    imageUrl:
      "https://gateway.pinata.cloud/ipfs/QmVgZRVWWHGkZ4inFtrPEZuQyQLqyARFR3KDLuG7ewokrX",
    name: "Celo Erectus",
    description: "1111 unique ERECTUS on the CELO blockchain",
    twitterUrl: "https://twitter.com/CeloErectus",
    celoUrl:
      "https://explorer.celo.org/address/0x56546DAF99C69c0F6271FA287b30A1946cA466f0/transactions",
  },
  {
    imageUrl:
      "https://ivanmolto.mypinata.cloud/ipfs/QmQ3y6sHVdQDAUk1tJbPUwKv3dEaX1N6UxEwcSqsYyrXq3",
    name: "Daopolis",
    description: "Automatically generated 9191 NFT's",
    twitterUrl: "https://twitter.com/cybertime_eth",
    celoUrl:
      "https://explorer.celo.org/address/0x1F25F8Df9E33033668d6F04DAE0bDE4854E9F1A5/transactions",
  },
  {
    imageUrl:
      "https://ivanmolto.mypinata.cloud/ipfs/QmX3miBNuokexrRbW6WhANU9nPTm5BGmuLL9FVKNwM5DHV",
    name: "CeloShapes",
    description: "A generative art collection living on the Celo blockchain",
    twitterUrl: "https://twitter.com/CeloShapesNFT",
    celoUrl:
      "https://explorer.celo.org/address/0x501F7Ea7B1aA25fF7D2feB3a2e96979ba754204B/transactions",
  },
  {
    imageUrl:
      "https://ivanmolto.mypinata.cloud/ipfs/QmbpgaxY5YzMgb9URD68Jtbc6PVZTZktbENp5kcfLYirgY",
    name: "CeloToadz",
    description:
      "First 6969 algorithmically generated Toadz with unique (modern) traits on Celo!",
    twitterUrl: "https://twitter.com/c_ToadzOfficial",
    celoUrl:
      "https://explorer.celo.org/address/0x6Fc1C8d59FdC261c55273f9b8e64B7E88C45E208/transactions",
  },
  {
    imageUrl:
      "https://ivanmolto.mypinata.cloud/ipfs/QmXCTBvjNsjnqzxtyeAE2N9tN3vdBWyuNf533k78iDVTJ9",
    name: "CelobrateCELO",
    description:
      "A Learn2Earn DAO governed by Knoxers NFT house & $KNOX token house",
    twitterUrl: "https://twitter.com/KnoxEdgeDAO",
    celoUrl:
      "https://explorer.celo.org/address/0x1F25F8Df9E33033668d6F04DAE0bDE4854E9F1A5/transactions",
  },
  {
    imageUrl:
      "https://ivanmolto.mypinata.cloud/ipfs/QmRNnkMqeGkEJtFet3NXNdG5XEDxcspjANUkL2b2KdddKJ",
    name: "NaviKatz Warriors",
    description: "Navikatz; Play, Stake, Capture, Earn!",
    twitterUrl: "https://twitter.com/NaviKatz",
    celoUrl: "",
  },
];

const Nfts = () => {
  return (
    <ul className="mx-auto px-4 sm:px-6 space-y-4 sm:space-y-0 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
      {projects.map((project) => (
        <li
          key={project.name}
          className="col-span-1 flex flex-col text-center bg-gray-800 rounded-lg shadow divide-y divide-gray-200"
        >
          <div className="flex-1 flex flex-col p-8">
            <img
              className="w-32 h-32 flex-shrink-0 mx-auto rounded-full"
              src={project.imageUrl}
              alt={project.name}
            />
            <h3 className="mt-6 text-white text-base font-medium font-jost">
              {project.name}
            </h3>
            <dl className="mt-1 flex-grow flex flex-col justify-between">
              <dt className="sr-only">Description</dt>
              <dd className="text-gray-200 text-sm">{project.description}</dd>
            </dl>
          </div>
          <div>
            <div className="-mt-px flex divide-x divide-gray-200">
              <div className="w-0 flex-1 flex">
                <a
                  href={project.twitterUrl}
                  rel="noreferrer"
                  target="_blank"
                  className="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-400 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
                >
                  <span className="sr-only">Twitter</span>
                  <svg
                    className="w-5 h-5"
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                </a>
              </div>
              <div className="-ml-px w-0 flex-1 flex">
                <a
                  href={project.celoUrl}
                  rel="noreferrer"
                  target="_blank"
                  className="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-400 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
                >
                  <span className="sr-only">Celo Explorer</span>
                  <svg
                    className="w-5 h-5"
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 950 950"
                  >
                    <path
                      id="Bottom_Ring"
                      data-name="Bottom Ring"
                      class="cls-1"
                      d="M375,850c151.88,0,275-123.12,275-275S526.88,300,375,300,100,423.12,100,575,223.12,850,375,850Zm0,100C167.9,950,0,782.1,0,575S167.9,200,375,200,750,367.9,750,575,582.1,950,375,950Z"
                    />
                    <path
                      id="Top_Ring"
                      data-name="Top Ring"
                      class="cls-1"
                      d="M575,650c151.88,0,275-123.12,275-275S726.88,100,575,100,300,223.12,300,375,423.12,650,575,650Zm0,100c-207.1,0-375-167.9-375-375S367.9,0,575,0,950,167.9,950,375,782.1,750,575,750Z"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default Nfts;
